interface MutedMessageProps {
  children: React.ReactNode;
}

export function MutedMessage({ children }: MutedMessageProps) {
  return <span className="italic">{children}</span>;
}
